//  document.addEventListener("DOMContentLoaded", function () {
//     const lenis = new Lenis({
//       duration: 1.2,
//       easing: (t) => 1 - Math.pow(1 - t, 4),
//       smooth: true,
//       smoothTouch: false
//     });

//     function raf(time) {
//       lenis.raf(time);
//       requestAnimationFrame(raf);
//     }

//     requestAnimationFrame(raf);
//   });


$(document).on('click', '.select_flavour_selected', function() {
  $(this).toggleClass('active');
  $(this).siblings('.select_flavour_option-wrp').toggleClass('active');
})
jQuery(function () {
  const $marquee = jQuery(".ct-marquee-track").marquee({
    direction: "left",
    duration: 50000,
    gap: 0,
    delayBeforeStart: 0,
    duplicated: true,
    startVisible: true
  });

  $marquee.hover(
    function () {
      jQuery(this).marquee("pause");
    },
    function () {
      jQuery(this).marquee("resume");
    }
  );
});
document.addEventListener('DOMContentLoaded', function () {
  const mediaGallery = document.querySelector('media-gallery');
  const mediaList = document.querySelector('.product__media-list');
  const dots = document.querySelectorAll('.ct-main-product .dot');

  if (!mediaGallery || !mediaList || !dots.length) return;
  function setActiveDot(index) {
    document.querySelector('.dot.active')?.classList.remove('active');
    const dot = document.querySelector(`.dot[data-index="${index}"]`);
    dot?.classList.add('active');
  }
  dots.forEach(dot => {
    dot.addEventListener('click', () => {
      const index = parseInt(dot.dataset.index);
      const offset = mediaList.children[index].offsetLeft;
      mediaList.scrollTo({
        left: offset,
        behavior: 'smooth'
      });
      setActiveDot(index);
    });
  });
  const observer = new MutationObserver(() => {
    const activeMedia = mediaList.querySelector('[media-id][aria-current="true"]');
    if (!activeMedia) return;
    const index = Array.from(mediaList.children).indexOf(activeMedia);
    if (index > -1) setActiveDot(index);
  });
  observer.observe(mediaList, { attributes: true, subtree: true, attributeFilter: ['aria-current'] });
  mediaList.addEventListener('scroll', () => {
    const scrollLeft = mediaList.scrollLeft;
    const childWidth = mediaList.children[0].clientWidth;

    const index = Math.round(scrollLeft / childWidth);
    setActiveDot(index);
  });
});

$(document).on('click', '.ingredient-tab_item', function(){
  let tab_index = $(this).index();
  $('.ingredient-tab_content, .ingredient-tab_item').removeClass('active');
  $(this).addClass('active');
  $('.ingredient-tab_content').eq(tab_index).addClass('active');
});

if(window.innerWidth < 750) {
  $(document).on('click', '.footer-block--menu .footer-block__heading', function(){
    // $('.footer-block--menu .footer-block__heading').removeClass('active');
    $(this).toggleClass('active');
    $(this).siblings('.footer-block__details-content').slideToggle();
  });
}

$(document).on('click', '.variant_item', function() {
  let parentnod = $(this).closest('.ct-product_card');
  parentnod.find('.variant_item').removeClass('active');
  $(this).addClass('active');
  let var_id = $(this).data('variant-id');
  console.log(var_id);
  let product_varId = parentnod.find('.product-variant-id');
  product_varId.val(var_id);
});